import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CameraRollIcon(props: IconProps) {
    return <Icon {...props} iconKey={"camera_roll"}/>
}
